import Tabs from "./Tabs";

export default Tabs;



// WEBPACK FOOTER //
// ./src/commonComponents/Tabs/index.js